
{
  "fr": {
    "configuratorHeaderBackButton": {
      "title": "Quitter"
    }
  }
}
